/**
 * Base controller for all TomSelect-backed <select>/<input> controllers.
 *
 * Handles the double-init guard, instantiation, teardown, and the shared
 * defaults (dropup positioning, hideSelected). Subclasses should override
 * `configuration(overrides)` to add plugins/fields and call
 * `super.configuration({...})`.
 *
 * `connect()` returns `true` if it actually created `this.tomselect`, or
 * `false` if the element already had a live TomSelect instance (guard hit).
 * Subclasses that touch `this.tomselect` right after `super.connect()`
 * must check that return value first, e.g.:
 *
 *   connect() {
 *     if (!super.connect()) return;
 *     this.tomselect.on(...);
 *   }
 */
import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    // Check if TomSelect is already initialized
    if (this.element.tomselect) {
      return false;
    }

    this.tomselect = new TomSelect(this.element, this.configuration());
    return true;
  }

  disconnect() {
    // Clean up TomSelect instance when controller disconnects
    if (this.tomselect) {
      this.tomselect.destroy();
      this.tomselect = null;
    }
  }

  configuration(overrides = {}) {
    const defaults = {
      hideSelected: true,
      onDropdownOpen: function (dropdown) {
        let bounding = dropdown.getBoundingClientRect();
        if (
          bounding.bottom >
          (window.innerHeight || document.documentElement.clientHeight)
        ) {
          dropdown.classList.add("dropup");
        }
      },
      onDropdownClose: function (dropdown) {
        dropdown.classList.remove("dropup");
      },
    };

    return { ...defaults, ...overrides };
  }
}
